import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useBotId } from '../../../../store/flow'
import { Button } from '../../../design-system/Button'
import { endpointHelpers } from '../../../../features/serverBots/endpointHelpers'
import { initiateBotArchivation } from '../../../../features/serverBots/actions/botDeactivation/initiateBotArchivation/initiateBotArchivation'

export const ArchiveBotButton: React.FC = () => {
  const botId = useBotId()
  const dispatch = useDispatch()
  const { isLoading } = useSelector(endpointHelpers.archiveBot.fixedKeySelector({ botId }))

  return (
    <Button
      size="medium"
      role="negative"
      label="Archive bot"
      emphasis="secondary"
      loading={isLoading}
      disabled={isLoading}
      minMaxSizes={{ minWidth: 100, maxHeight: 36 }}
      onClick={async event => {
        event.preventDefault()
        dispatch(initiateBotArchivation(botId))
      }}
    />
  )
}
